import axios from "axios";
import app from "../main";
import router from "../router";
import store from "../store";

const API_URL = "https://pediatrim.net";

// const API_URL = "http://192.168.1.45/pediatrim/dist";

const instance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  /*     headers: {
            Authorization: {
                toString() {
                    return `Bearer ${localStorage.getItem('pediatrimID')}`
                }
            }
        } */
});

instance.interceptors.request.use(
  (config) => {
    app.$Progress.start(); // for every request start the progresss
    return config;
  },
  function(error) {
    app.$Progress.fail();
    app.$snotify.error("İstek gönderilemedi. Sunucu ile bağlantı kurulamıyor");
    return Promise.reject(error.response.statusText);
  }
);

instance.interceptors.response.use(
  (response) => {
    app.$Progress.finish();
    return response;
  },
  function(error) {
    app.$Progress.fail();
    if (!error.response) {
      if (router.currentRoute.path != "/error") {
        store.dispatch("toggleAppMode", -1).then(() => {
          router.push("/error");
        });
      }
    } else {
      switch (error.response.status) {
        case 401:
          if (router.currentRoute.path != "/login") {
            router.push("/login");
          }
          break;
        case 503:
          if (router.currentRoute.path != "/bakim") {
            store.dispatch("toggleAppMode", 0).then(() => {
              router.push("/bakim");
            });
          }
          break;
        default:
          app.$snotify.error(error.response.statusText, "Hata");
          break;
      }
    }
    return Promise.reject(error.response.statusText);
  }
);

export default instance;
